module.exports = __webpack_public_path__ + "img/kf2.d30f5e63.png";